/** Firestore path segment: users/{uid}.lastRead.{module}.{itemKey} */
export const LAST_READ_MODULES = {
  ARTICLES: 'articles',
  DOCUMENTS: 'documents',
  NOTICES: 'notices',
  BENEFITS: 'benefits',
  POLLS: 'polls',
  QNA: 'qna',
  CHAT: 'chat',
};
